import LOGO from "../images/FloresMagon.png";

export const Team__FloresMagon = {
  name: "Flores Magon",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#8B4513",
  teamJerseyColor: "#D97706",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 49 + 39 + 28,
  goalsScoredAgainst: 52 + 48 + 40,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
